<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView } from 'vue-router'

import { useAuthStore } from '@/stores/auth-store'

import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import CrumbsAndActions from '@/components/layout/CrumbsAndActions.vue'
import MyPanel from '@/components/my-components/MyPanel.vue'
import PackagingOrdersTable from '@/components/packaging/PackagingOrdersTable.vue'
import MyButton from '@/components/my-components/MyButton.vue'
import ManagePackagingOrderModal from '@/components/packaging/ManagePackagingOrderModal.vue'

const { t } = useI18n()
const authStore = useAuthStore()

const manageModalOpen = ref(false)

const statusIndicators = computed(() => [
    { color: 'bg-blue-400', label: t('created') },
    { color: 'bg-yellow-400', label: t('accepted') },
    { color: 'bg-green-500', label: t('finished') },
    { color: 'bg-red-500', label: t('canceled') },
])
</script>

<template>
    <CrumbsAndActions v-if="authStore.companyId">
        <Breadcrumb :to="{ name: 'packaging' }" v-text="t('packaging')" />
        <Breadcrumb current v-text="t('packagingOrder')" />
        <template #actions>
            <MyButton plain scheme="primary" size="small" @click="manageModalOpen = true">
                <mdi:plus-thick class="mr-1" />
                {{ t('addPackagingOrder') }}
            </MyButton>
        </template>
    </CrumbsAndActions>

    <RouterView />

    <div v-if="authStore.companyId">
        <div class="flex space-x-4 p-3 text-xs uppercase">
            <div
                v-for="(status, index) in statusIndicators"
                :key="index"
                class="flex items-center space-x-1"
            >
                <div :class="['w-3 aspect-square rounded-full', status.color]" />
                <span class="font-semibold" v-text="status.label" />
            </div>
        </div>

        <MyPanel shadow>
            <PackagingOrdersTable />
        </MyPanel>

        <ManagePackagingOrderModal v-model="manageModalOpen" @close="manageModalOpen = false" />
    </div>
</template>
